import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import { SIZES } from '../styles/theme'
import { desktopAssets, mobileAssets } from 'src/containers/PreCache'

const Wrapper = styled.div`
  min-height: 100dvh;
  background-image: url(${desktopAssets.landingBg});
  background-size: cover;
  background-position: center;
  padding-inline: 16px;

  .header-logo {
    max-width: 961px;
    width: 100%;
    height: auto;
  }

  .wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .content-wrapper {
    background: rgba(30, 30, 30, 0.7);
    backdrop-filter: blur(3px);
    color: #fff;
    padding-block: 40px;
  }

  .countdown-container {
    background: rgba(30, 30, 30, 0.7);
    backdrop-filter: blur(3px);
    padding-block: 21px;
    border-radius: 10px;
  }

  .countdown-title {
    font-size: 1rem;
    text-transform: uppercase;
    color: #fff;
    text-align: center;
    margin-bottom: 1rem;
  }

  .time-wrapper {
    margin: 0 auto;
    display: flex;
    padding-inline: 45px;
    gap: 10px;

    ${SIZES.mobile} {
      margin-right: auto;
    }
    .time-card {
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 0rem;
      flex: 1;

      p {
        font-weight: 400;
        position: relative;
        color: #fff;
        font-size: 14px;
        margin: 0;
        text-transform: uppercase;
        line-height: 1.875rem;
      }

      h2 {
        font-weight: 900;
        font-size: 2rem;
        margin: 0;
        position: relative;
        line-height: normal;
      }
    }
  }
`

export default function CountdownTimerMobile() {
  const calculateTimeLeft = () => {
    const { year, month, day, hour, minute } = config.EVENT_START_TIME
    const difference = +new Date(year, month - 1, day, hour, minute, 0, 0) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      const newTimeLeft = calculateTimeLeft()
      setTimeLeft(newTimeLeft)

      // Check if countdown has reached zero and refresh page
      if (Object.keys(newTimeLeft).length === 0) {
        window.location.reload()
      }
    }, 1000)

    // Cleanup function to clear the timer
    return () => clearTimeout(timer)
  }, [timeLeft])

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    if (isNaN(timeLeft[interval])) {
      return
    }

    timerComponents.push(
      <div className="time-card" key={interval}>
        <h2>{timeLeft[interval]}</h2>
        <p>{interval}</p>
      </div>
    )
  })

  const eventStarted = !timerComponents.length

  if (eventStarted) {
    return <></>
  }

  return (
    <Wrapper>
      <div className="pt-5">
        <img src={mobileAssets.countdownKvMobile} alt="PVE 2025" style={{ width: '100%', height: 'auto', margin: '0 auto', marginBottom: '24px' }} />
      </div>
      <div className="countdown-container ">
        <h4 className="countdown-title">READY TO LIVE IN</h4>
        <div className="time-wrapper">{timerComponents.length && timerComponents}</div>
      </div>
    </Wrapper>
  )
}
